import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable multiline-ternary */
/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { arrayOf, bool, number, shape, string } from 'prop-types';
import styled from '@emotion/styled';
import { Grid, GridItem } from '@nike/nike-design-system-components';
import Imagetext from '../Imagetext/Imagetext';
import Multicolumntile from '../Multicolumntile/Multicolumntile';
import Notification from '../Notification/Notification';
import QuickEdit from '../QuickEdit/QuickEdit';
import Salesinformation from '../Salesinformation/Salesinformation';
import Slider from '../Slider/Slider';
import VideoComponent from '../Video/Video';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var GridWrapper = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media (min-width: 1920px) {\n    div.nds-grid-container:first-of-type {\n      margin-right: 0px;\n      margin-left: 0px;\n      max-width: 100%;\n    }\n\n    div.nds-grid:first-of-type {\n      max-width: 100%;\n    }\n  }\n"])));
function Homepages(props) {
  var linkHost = props.linkHost,
    mediaHost = props.mediaHost,
    isVisualizer = props.isVisualizer,
    isAuthor = props.isAuthor,
    notification = props.notifications,
    _props$p = _slicedToArray(props.p1, 1),
    p1 = _props$p[0],
    p21 = props.p21,
    _props$p2 = _slicedToArray(props.p22, 1),
    p22 = _props$p2[0],
    _props$p3 = _slicedToArray(props.p3, 1),
    p3 = _props$p3[0],
    _props$p4 = _slicedToArray(props.p4, 1),
    p4 = _props$p4[0],
    _props$p5 = _slicedToArray(props.p5, 1),
    p5 = _props$p5[0];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [notification.length > 0 ? /*#__PURE__*/_jsx(Notification, _objectSpread(_objectSpread({
      mediaHost: mediaHost,
      isAuthor: isAuthor
    }, [notification[0]][0]), props)) : null, /*#__PURE__*/_jsx(GridWrapper, {
      children: /*#__PURE__*/_jsxs(Grid, {
        rowGapXs: "14px",
        exteriorGapXs: "0px",
        children: [/*#__PURE__*/_jsxs(GridItem, {
          style: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0
          },
          xs: 12,
          children: [isVisualizer && p1 ? /*#__PURE__*/_jsx(QuickEdit, _objectSpread({
            p1: [p1],
            p21: p21,
            p22: [p22],
            p3: [p3],
            p4: [p4],
            p5: [p5]
          }, props)) : null, /*#__PURE__*/_jsx(Imagetext, _objectSpread(_objectSpread({}, p1), {}, {
            mediaHost: mediaHost,
            linkHost: linkHost,
            buttonColors: {
              leftButtonColor: 'white',
              rightButtonColor: 'black'
            },
            size: "large",
            placement: "p1",
            defaultImageWidth: "1920",
            defaultImageLength: "820"
          }, props))]
        }), /*#__PURE__*/_jsx(GridItem, {
          xs: 8,
          style: {
            paddingLeft: 0
          },
          children: /*#__PURE__*/_jsx(Slider, _objectSpread({
            slides: p21,
            linkHost: linkHost,
            mediaHost: mediaHost,
            placement: "p21"
          }, props))
        }), /*#__PURE__*/_jsx(GridItem, {
          xs: 4,
          style: {
            paddingRight: 0
          },
          children: /*#__PURE__*/_jsx(Imagetext, _objectSpread(_objectSpread({}, p22), {}, {
            linkHost: linkHost,
            mediaHost: mediaHost,
            placement: "p22"
          }, props))
        }), p3 ? /*#__PURE__*/_jsx(VideoComponent, _objectSpread(_objectSpread({}, p3), {}, {
          mediaHost: mediaHost,
          placement: "p3"
        }, props)) : [], /*#__PURE__*/_jsx(Multicolumntile, _objectSpread(_objectSpread({}, p4), {}, {
          mediaHost: mediaHost,
          linkHost: linkHost,
          placement: "p4"
        }, props)), /*#__PURE__*/_jsx(GridItem, {
          xs: 12,
          style: {
            paddingLeft: 0,
            paddingRight: 0
          },
          children: /*#__PURE__*/_jsx(Salesinformation, _objectSpread({
            placement: "p5",
            linkHost: linkHost,
            isVisualizer: isVisualizer,
            xfPath: p5.xfPath,
            title: p5['jcr:title'],
            viewAllText: p5.viewAllText,
            hasMultipleSalesInformationWidgets: Object.keys(p5.root).filter(function (item) {
              return item.startsWith('salesinformation');
            }).length > 1
            // We want to only show the first Sales Information on the homepage
            ,
            root: p5.root[Object.keys(p5.root).filter(function (item) {
              return item.startsWith('salesinformation');
            })[0]]
          }, props))
        })]
      })
    })]
  });
}
Homepages.propTypes = {
  notifications: arrayOf(shape({
    length: number
  })).isRequired,
  linkHost: string.isRequired,
  mediaHost: string.isRequired,
  isVisualizer: bool.isRequired
};
export default Homepages;